var $ = require('jquery');

var tb,
tabs = {
    settings: {
        accTabItem: $('.block.tabs .tab-item'),
        accItem: $('.block.tabs details'),
        accMenuTab: $('.block.tabs .tab-title'),
        breakpoint: 860
    },
    init: function() {
        tb = this.settings;
        this.bindUIActions();
    },
    bindUIActions: function() {
        // Add media query to tab view at tb.breakpoint
        var windowSize = $(window).width();
        // Get width of window on load or resize
        $(window).on('load resize', function() {
            windowSize = $(window).width();

            if ( windowSize >= tb.breakpoint ) {
                $('.block.tabs .tab-content').css('display', 'block');

                // console.log(tb.accTabItem);
                var hasActiveClass = false;
                for ( var i = 0; i < tb.accTabItem.length; i++ ) {
                    if ( $(tb.accTabItem[i]).hasClass('active') ) {
                        hasActiveClass = true;
                        // console.log('An accordion was found with an active class.');
                        break
                    }
                }

                if (hasActiveClass == false) {
                    // console.log('None of the accordions have an active class.');
                    // Add active class to first accordion in tab view when screens are larger than tb.breakpoint
                    $('.block.tabs .tab-item:first-child').addClass('active');
                }
            } else if ( windowSize < tb.breakpoint ) {
                $('.block.tabs .tab-item').removeClass('active');
                $('.tab-content').css('display', 'none');
            }
        });

        // Tab View, < tb.breakpointpx
        $('.block.tabs .tab-item').on('click', function (evt) {
            if($(evt.target).hasClass('tab-content') || $(evt.target).parents('.tab-content').length > 0){
                
            } else {
                if ( windowSize < tb.breakpoint ) {
                    evt.preventDefault();
                    this.classList.toggle('active');
                    $(this).find('.tab-content').slideToggle( '3000', function() {
                        // Animation complete.
                    });
                }
            }
        });

        // Tab View — Disable accordion functionality
        $('.block.tabs summary').on('click', function(evt) {
            if ( windowSize >= tb.breakpoint ) {
                evt.preventDefault();
            }
        });

        // Tab View — Menu Selection
        $('.block.tabs .tab-title').on('click', function (evt) {
            var parentElement = $(this).parents('.block.tabs');
            parentElement.find('.tab-title').removeClass('active');
            parentElement.find('.tab-menu').removeClass('active');
            parentElement.find('.tab-nav-item').removeClass('active');
            parentElement.find('.tab-group').removeClass('active');

            // Add active class to selected tab
            $(this).addClass('active');

            var selectedItem = $(this).attr('data-tab');

            // Add active class to tab menu & first nav item
            parentElement.find('.tab-menu[data-tab="'+selectedItem+'"]').addClass('active');
            parentElement.find('.tab-menu[data-tab="'+selectedItem+'"] .tab-nav-item').first().addClass('active');
            parentElement.find('.tab-group[data-tab="'+selectedItem+'"]').addClass('active');
            tabs.adjustHeights(parentElement);

        });

        // Tab View — Show selected accordion
        $('.block.tabs .tab-nav-item a').on('click', function (evt) {
            $(this).parent().siblings().removeClass('active');
            $(this).parent().addClass('active');

            // Define elements
            var selectedSubItem = $(this).parent().attr('data-accordion');

            // Remove active class from all accordions
            $(this).parents('.block.tabs').find('.tab-group.active .tab-item').removeClass('active');
            // Add active class to selected accordion
            $(this).parents('.block.tabs').find('.tab-group.active .tab-item[data-accordion="' + selectedSubItem + '"]').addClass('active');
            tabs.adjustHeights($(this).parents('.block.tabs'));
        });

    },
    adjustHeights: function(parentElement){
        var activeTabMenu = parentElement.find('.tab-menu.active'),
            activeTabContent = parentElement.find('.tab-group.active .tab-item.active');

        if(activeTabMenu.outerHeight() > activeTabContent.outerHeight()){
            parentElement.find('.tab-group.active .tab-item').css('min-height', 0);
            activeTabContent.css('min-height', activeTabMenu.outerHeight());
        } else {
            parentElement.find('.tab-group.active .tab-item').css('min-height', 0);
        }

    }
};
    
module.exports = tabs;